import { createContext, useContext } from 'react';
export const DetailsPageContext = /*#__PURE__*/createContext({
  appContext: 'app',
  iconUrl: '',
  name: '',
  productType: 'APP',
  published: true,
  userInfo: {}
});
export const useDetailsPageContext = () => {
  const context = useContext(DetailsPageContext);
  if (!context) {
    throw new Error('useDetailsPageContext must be used within a DetailsPageContext.Provider');
  }
  return context;
};